import { useApi } from './useApi'

// Catálogos por-registro: grupos de predicación, zonas y conductores/capitanes.
// Cada uno con operaciones por id (crear/editar/borrar), para evitar sobreescrituras
// entre navegadores. Reemplaza el manejo de estos campos vía el blob de /api/config.
export const useCatalogos = () => {
  const api = useApi()

  return {
    // Grupos de predicación
    getGrupos: () => api.get('/api/grupos'),
    createGrupo: (payload) => api.post('/api/grupos', payload),
    updateGrupo: (id, payload) => api.put(`/api/grupos/${id}`, payload),
    deleteGrupo: (id) => api.del(`/api/grupos/${id}`),

    // Zonas (otras congregaciones)
    getZonas: () => api.get('/api/zonas'),
    createZona: (payload) => api.post('/api/zonas', payload),
    updateZona: (id, payload) => api.put(`/api/zonas/${id}`, payload),
    deleteZona: (id) => api.del(`/api/zonas/${id}`),

    // Conductores / capitanes de salidas
    getConductores: () => api.get('/api/conductores'),
    createConductor: (payload) => api.post('/api/conductores', payload),
    updateConductor: (id, payload) => api.put(`/api/conductores/${id}`, payload),
    deleteConductor: (id) => api.del(`/api/conductores/${id}`),
  }
}
